// src/components/dashboard/client/DossierAgenda.js
import React from "react";

const DossierAgenda = () => {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Agenda du Dossier</h2>
      <p>Cette section affichera le calendrier des interventions pour le dossier.</p>
      {/* Ajoutez ici votre calendrier et la logique associée */}
    </div>
  );
};

export default DossierAgenda;
